import intl from 'react-intl-universal'
import { LOCALE } from '@foxrenderfarm/internals'
import { getLocalAppOrigin, isPathActive, MainLink } from '../../light-dropdowns/common'

interface AboutPanelProps {
  currentLocale: LOCALE
  currentPathname: string
  origin: string
}

export const AboutPanel = ({ currentLocale, currentPathname, origin }: AboutPanelProps) => {
  const useGatsbyLink = process.env.GATSBY_PACKAGE_NAME === 'main'
  const mainOrigin = getLocalAppOrigin(origin, 8084)

  const items = [
    {
      key: 'company',
      name: intl.get('index.header.about.company'),
      to: '/about.html',
    },
    {
      key: 'global-resellers',
      name: intl.get('index.header.about.global.resellers'),
      to: '/global-partner.html',
    },
    {
      key: 'partners',
      name: intl.get('index.header.about.partners'),
      to: '/partner.html',
    },
  ]

  return (
    <>
      {items.map((item) => (
        <MainLink
          key={item.key}
          to={item.to}
          href={`${mainOrigin}${item.to}`}
          useGatsbyLink={useGatsbyLink}
          locale={currentLocale}
          $highlight={isPathActive(currentPathname, item.to, currentLocale)}
        >
          {item.name}
        </MainLink>
      ))}
    </>
  )
}
